export default __webpack_public_path__ + "static/imgTree-224daa3f4fb651034595b3080a9df88d.webp";